import {RouteConfig} from 'vue-router';

export default [] as RouteConfig[];
